import React, { useCallback } from 'react';
import { Trans, useTranslation as useTranslationI18next } from 'react-i18next';
const RICH_TEXT_COMPONENTS = {
    b: /*#__PURE__*/ React.createElement("b", null),
    i: /*#__PURE__*/ React.createElement("i", null),
    span: /*#__PURE__*/ React.createElement("span", null)
};
const INVALID_TRANSLATION = 'Invalid Translation';
export const useTranslation = ()=>{
    const { t: i18nextT, i18n } = useTranslationI18next();
    const t = useCallback((id, options)=>{
        const key = typeof id == 'string' ? id : id.key;
        const opts = typeof id == 'string' ? options : id.options;
        try {
            const result = i18nextT(key, {
                ...opts,
                interpolation: {
                    escapeValue: false
                }
            });
            return typeof result == 'string' ? result : INVALID_TRANSLATION;
        } catch  {
            return INVALID_TRANSLATION;
        }
    }, [
        i18nextT
    ]);
    const tArray = useCallback((key, options)=>{
        try {
            const result = i18nextT(key, {
                ...options,
                returnObjects: true
            });
            if (!Array.isArray(result)) return [
                INVALID_TRANSLATION
            ];
            return result.map((item)=>typeof item == 'string' ? item : INVALID_TRANSLATION);
        } catch  {
            return [
                INVALID_TRANSLATION
            ];
        }
    }, [
        i18nextT
    ]);
    return {
        t: t,
        tArray: tArray,
        language: i18n.language
    };
};
export const T = (props)=>{
    const i18nKey = typeof props.id == 'string' ? props.id : props.id.key;
    const values = typeof props.id == 'string' ? props.options : props.id.options;
    return /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: i18nKey,
        values: values !== null && values !== void 0 ? values : {},
        components: RICH_TEXT_COMPONENTS,
        tOptions: {
            interpolation: {
                escapeValue: false
            }
        }
    });
};
export const TList = (props)=>{
    const { tArray } = useTranslation();
    if (typeof props.id == 'string') {
        const items = tArray(props.id);
        return /*#__PURE__*/ React.createElement("ul", null, items.map((_, index)=>/*#__PURE__*/ React.createElement("li", {
                key: index
            }, /*#__PURE__*/ React.createElement(T, {
                id: `${props.id}.${index}`
            }))));
    }
    return /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement(T, {
        id: props.id
    }));
};
